import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#D33A5A"
      d="M22.25 4C19.668 4 17.41 5.11 16 6.984 14.59 5.11 12.332 4 9.75 4A7.764 7.764 0 0 0 2 11.75c0 8.75 12.973 15.832 13.527 16.125a1 1 0 0 0 .473.121 1 1 0 0 0 .473-.121C17.027 27.582 30 20.5 30 11.75A7.764 7.764 0 0 0 22.25 4m0 0"
    />
  </svg>
);
const SvgIconLoveFilled = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconLoveFilled);
export default Memo;
